<ng-container *ngIf="['hms', 'hm'].indexOf(displayMode) >= 0">
    <mat-form-field [color]="color"
                    [floatLabel]="'auto'"
                    [hintLabel]="'hours' | translate">
<!--      <mat-label>{{'hh' | translate}}</mat-label>-->
      <input matInput
               [formControl]="hoursFormControl"
               class="text-right"
               type="number"
               name="1"
               min="0"
               maxlength="{{ INPUT_MAX_LENGTH }}">
        <mat-error *ngIf="hoursFormControl.hasError('minValue')">{{ 'Min_value' | translate: { value: min } }} {{ 'seconds' | translate }}</mat-error>
        <mat-error *ngIf="hoursFormControl.hasError('maxValue')">{{ 'Max_value' | translate: { value: max } }} {{ 'seconds' | translate }}</mat-error>
        <mat-error *ngIf="hoursFormControl.hasError('invalidValue')">{{ 'Invalid_value' | translate }}</mat-error>
    </mat-form-field>
    <span class="separator">:</span>
</ng-container>
<mat-form-field *ngIf="['hms', 'hm', 'ms'].indexOf(displayMode) >= 0"
                [color]="color"
                [floatLabel]="'auto'"
                [hintLabel]="'minutes' | translate">
<!--  <mat-label>{{'mm' | translate}}</mat-label>-->
    <input matInput
           [formControl]="minutesFormControl"
           [class.text-right]="['ms'].indexOf(displayMode) >= 0"
           [class.text-center]="['hms'].indexOf(displayMode) >= 0"
           type="number"
           name="2"
           min="0"
           maxlength="{{ INPUT_MAX_LENGTH }}">
    <ng-container *ngIf="displayMode === 'ms'">
        <mat-error *ngIf="minutesFormControl.hasError('minValue')">{{ 'Min_value' | translate: { value: min } }} {{ 'seconds' | translate }}</mat-error>
        <mat-error *ngIf="minutesFormControl.hasError('maxValue')">{{ 'Max_value' | translate: { value: max } }} {{ 'seconds' | translate }}</mat-error>
    </ng-container>
    <mat-error *ngIf="minutesFormControl.hasError('invalidValue')">{{ 'Invalid_value' | translate }}</mat-error>
</mat-form-field>
<span *ngIf="['hms', 'ms'].indexOf(displayMode) >= 0" class="separator">:</span>
<mat-form-field *ngIf="['hms', 'ms', 's'].indexOf(displayMode) >= 0"
                [color]="color"
                [floatLabel]="'auto'"
                [hintLabel]="'seconds' | translate">
<!--  <mat-label>{{'ss' | translate}}</mat-label>-->
    <input matInput
           [formControl]="secondsFormControl"
           [class.text-right]="['s'].indexOf(displayMode) >= 0"
           type="number"
           min="0"
           name="3"
           maxlength="{{ INPUT_MAX_LENGTH }}">
    <ng-container *ngIf="displayMode === 's'">
        <mat-error *ngIf="secondsFormControl.hasError('minValue')">{{ 'Min_value' | translate: { value: min } }} {{ 'seconds' | translate }}</mat-error>
        <mat-error *ngIf="secondsFormControl.hasError('maxValue')">{{ 'Max_value' | translate: { value: max } }} {{ 'seconds' | translate }}</mat-error>
    </ng-container>
    <mat-error *ngIf="secondsFormControl.hasError('invalidValue')">{{ 'Invalid_value' | translate }}</mat-error>
</mat-form-field>
<div class="label">{{ label }}</div>
